import { useParams } from "react-router-dom";
import FormAgente from "./formulario";

export function AgenteIncluir() {
  const idagente = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <FormAgente idagente={idagente.id} acao="Novo" />
      </div>
    </>
  );
} 